"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmrType = exports.getParser = exports.PatientEmrParser = void 0;
var PatientEmrParser_1 = require("./PatientEmrParser");
Object.defineProperty(exports, "PatientEmrParser", { enumerable: true, get: function () { return PatientEmrParser_1.PatientEmrParser; } });
Object.defineProperty(exports, "getParser", { enumerable: true, get: function () { return PatientEmrParser_1.getParser; } });
var EmrConstants_1 = require("./EmrConstants");
Object.defineProperty(exports, "EmrType", { enumerable: true, get: function () { return EmrConstants_1.EmrType; } });
